const labelMappings = {
    ROLE_USER: 'Utilisateur',
    ROLE_COACH: 'Coach',
    ROLE_REFERENT: 'Référent',
    ROLE_ADMIN: 'Administrateur',
    email: 'Email',
    sms: 'SMS',
    sms_seance_annulation: 'SMS annulation de séance',
    email_seance_annulation: 'Email annulation de séance',
    email_utilisateur_confirmation_compte: 'Email confirmation de compte',
    email_utilisateur_confirmation_compte_relance: 'Email relance confirmation de compte',
    email_absence_coach: 'Email absence coach',
    sms_asu_attente_to_valide: "Sms participant en file d'attente",
    email_referent_stats_du_mois: 'Email référent stats du mois',
    sms_utilisateur_participation_seance_24h: 'SMS utilisateur participation séance dans 24h',
    email_seance_passee_validation_coach: 'Email validation seance coach',
    sms_coach_message_participants: 'SMS coach message participants',
    email_seance_date_update: 'Email séance date mise à jour',
    email_seance_notif_dispo: 'Email  notification séance disponible',
    email_seance_notif_new: 'Email notification nouvelle séance',
    email_rappel_notation: 'Email rappel notation',
    email_seance_passee_validation_coach_relance: 'Email séance passée validation coach relance',
    email_reset_password: 'Email réinitialisation mot de passe',
};

export const getLabel = (key) => {
    return labelMappings[key] || key;
};

export const getLabelFromList = (key, list) => {
    return list.find(item => item.value === key).label;
};

export const getLabelFromListValue = (key, list) => {
    return list.find(item => item.value === key).label;
};

export const getLabelFromListKey = (key, list) => {
    return list.find(item => item.key === key).label;
};